import { Box } from "@mui/material"

export const Logo = () => (
  <Box sx={{ fontSize: 25, fontStyle: "italic" }}>
    <span style={{ color: "black" }}>Ag</span>
    <span style={{ color: "rgba(220, 38, 38)" }}>Lease</span>
    <span style={{ color: "rgba(251, 191, 36)" }}>Co</span>
  </Box>
)
